"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _core = require("@material-ui/core");

var styles = function styles(theme) {
  return {
    '@global': {
      html: {
        height: '100%'
      },
      body: (0, _extends2["default"])({}, theme.typography.body1, {
        height: '100%',
        minHeight: '100%',
        position: 'relative'
      }),
      // https://css-tricks.com/numeric-inputs-a-comparison-of-browser-defaults/
      // Removes the spinner from Safari
      'input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      // Removes spinner from Firefox
      'input[type=number]': {
        '-moz-appearance': 'textfield'
      }
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);

var Baseline = function Baseline() {
  useStyles();
  return /*#__PURE__*/_react["default"].createElement(_core.CssBaseline, null);
};

var _default = Baseline;
exports["default"] = _default;